import { IReduxAction } from '~/services/interfaces/common-interface';
import {
  SET_LOADING_DATA,
  SET_PAGE,
  SET_ROWS_PER_PAGE,
  SET_ROWS_COUNT,
  SET_ORDER,
  SET_ORDERBY,
  SET_LOADING_SELECTS,
  GET_LIST_ALL_SUCCESS,
  GET_LIST_SELECTS_SUCCESS
} from './vendor-client-visit-constants';

const INITIAL_STATE = {
  loadingData: false,
  loadingSelects: false,
  list: {
    hasRemotePagination: false,
    allRows: [],
    rows: [],
    rowsCount: 0,
    page: 0,
    rowsPerPage: 10,
    rowsPerPageOptions: [10, 25, 50, 100],
    order: 'desc',
    orderBy: 'date',
    selects: {
      clients: []
    }
  }
};

const vendorClientVisitReportChecklist = (state: any = { ...INITIAL_STATE }, action: IReduxAction) => {
  switch (action.type) {
    case SET_LOADING_DATA: {
      return {
        ...state,
        loadingData: action.loading
      };
    }

    case SET_LOADING_SELECTS: {
      return {
        ...state,
        loadingSelects: action.loading
      };
    }

    case GET_LIST_ALL_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          rows: action.payload?.dailyReports,
          allRows: action.payload?.dailyReports,
          rowsCount: action.payload?.rowsCount ?? state?.list?.rowsCount
        }
      };
    }

    case GET_LIST_SELECTS_SUCCESS: {
      return {
        ...state,
        list: {
          ...state.list,
          selects: action.payload?.selects
        }
      };
    }

    case SET_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          page: action.page
        }
      };
    }

    case SET_ROWS_PER_PAGE: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsPerPage: action.rowsPerPage
        }
      };
    }

    case SET_ROWS_COUNT: {
      return {
        ...state,
        list: {
          ...state.list,
          rowsCount: action.rowsCount
        }
      };
    }

    case SET_ORDER: {
      return {
        ...state,
        list: {
          ...state.list,
          order: action.order
        }
      };
    }

    case SET_ORDERBY: {
      return {
        ...state,
        list: {
          ...state.list,
          orderBy: action.orderBy
        }
      };
    }

    default:
      return state;
  }
};

export default vendorClientVisitReportChecklist;
